/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import HubPageGoogleSchemaMarkup from 'bundles/premium-hub/components/seo/HubPageGoogleSchemaMarkup';
import PremiumHubPageHeader from 'bundles/premium-hub/components/shared/PremiumHubPageHeader';
import { HubPages, UnifiedHubProductVariant } from 'bundles/premium-hub/constants';
import usePremiumHubPageData from 'bundles/premium-hub/hooks/usePremiumHubPageData';
import OverviewPageContent from 'bundles/premium-hub/pages/subpages/OverviewPageContent';
import { convertDegreeCategoryFieldsToPPCDegreeCategory } from 'bundles/premium-hub/utils/dataTransformationUtils';

const CoreHubPageContent = () => {
  const pageType = HubPages.MainHubPage;
  const premiumHubPageData = usePremiumHubPageData(pageType);

  if (!premiumHubPageData) {
    return null;
  }

  const { degreeCategories, premiumProductList, useSimplifiedHeader = false } = premiumHubPageData;

  return (
    <>
      <PremiumHubPageHeader isSimplified={useSimplifiedHeader} />
      <main className="rc-DegreesHubPage" data-e2e="DegreeHubPage">
        <HubPageGoogleSchemaMarkup
          categories={degreeCategories?.map(convertDegreeCategoryFieldsToPPCDegreeCategory) ?? []}
          productList={
            premiumProductList?.map((product) => ({ ...product, productVariant: UnifiedHubProductVariant.Degree })) ??
            []
          }
        />
        <OverviewPageContent {...premiumHubPageData} currentPageType={pageType} shouldShowDriftChat={true} />
      </main>
    </>
  );
};

export default compose<{}, React.PropsWithChildren<{}>>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'program_hub',
      page: 'degree_main',
    },
  }))
)(CoreHubPageContent);
